export const defaultPersonData = {
  generalData: {
    /**
     * taxRegime is a field needed for certain backend operations and
     * most of the time the services require it, even if it's not shown for the
     * user.
     * */
    taxRegime: '0',
    name: 'Rulo',
    firstLastname: '',
    secondLastname: '',
    birthdate: '',
    gender: '',
    rfc: '',
  },
  personalData: {
    email: '',
    cellphone: '',
    maritalStatus: '',
    occupation: '',
  },
  generalMoralData: {
    moralTaxRegime: '',
    moralRfc: '',
    socialReason: '',
  },
  representativePersonData: {
    representativeName: '',
    representativeFirstLastname: '',
    representativeSecondLastname: '',
    representativeEmail: '',
    representativeCellphone: '',
    representativeBirthdate: '',
  },
  address: {
    postalCode: '',
    state: '',
    municipality: '',
    colony: '',
    street: '',
    noExt: '',
    noInt: '',
  },
  additionalData: {
    activity: '',
    sourceIncome: '',
    nationality: '',
    isOlderThan30: '',
  },
};

export const cleanedValuesPersonData = {
  /**
 * taxRegime is a field needed for certain backend operations and
 * most of the time the services require it, even if it's not shown for the
 * user.
 * */
  taxRegime: '0',
  name: '',
  firstLastname: '',
  secondLastname: '',
  birthdate: '',
  rfc: '',
  email: '',
  cellphone: '',
  gender: '',
  maritalStatus: '',
  occupation: '',
  moralTaxRegime: '',
  moralRfc: '',
  socialReason: '',
  representativeName: '',
  representativeFirstLastname: '',
  representativeSecondLastname: '',
  representativeEmail: '',
  representativeCellphone: '',
  postalCode: '',
  state: '',
  municipality: '',
  colony: '',
  street: '',
  noExt: '',
  noInt: '',
  activity: '',
  sourceIncome: '',
  nationality: '',
};
